module.exports = __webpack_public_path__ + "img/Weapon_129.16bd76af.png";